import React from "react";
import { Trans, useTranslation } from 'react-i18next';
import "./Footer.css";
import { DateTime } from 'luxon';
import fitLogoCs from "../../../assets/fit-logo-cz.svg";
import fitLogoEn from "../../../assets/fit-logo-en.svg";

function Footer({
        latestMeetingAt,
        latestMeetingNumber,
        timeZone
    }: {
        latestMeetingAt?: string,
        latestMeetingNumber?: string,
        timeZone?: string
    }) {
    const year = new Date().getFullYear();
    const { t, i18n } = useTranslation();

    const currentLocale = i18n.language;
    const isEnglish = currentLocale?.startsWith('en');

    let formattedDate: string | null = null;

    if (latestMeetingAt) {
        const dt = DateTime.fromISO(latestMeetingAt, { zone: timeZone });
        if (dt.isValid) {
            formattedDate = dt.setLocale(currentLocale).toLocaleString(DateTime.DATE_MED);
        }
    }
    return(
        <footer className="site-footer">
            <div className="site-footer__container">
                <div className="site-footer__info">
                    <p className="site-footer__text"> &copy; {year} Zastupko </p>
                    { latestMeetingAt && latestMeetingNumber
                        ? <p className="site-footer__text"> {t("Footer.footerText", { num: latestMeetingNumber, date: formattedDate })} </p>
                        : <></>
                    }
                </div>
                <div className="site-footer__academic">
                    <a
                        className="site-footer__fit-logo-link"
                        href={t("Footer.fitLink")}
                        target="_blank"
                        rel="noreferrer"
                        aria-label={t("Footer.fitLogoAlt")}
                    >
                        <img
                            className="site-footer__fit-logo"
                            src={isEnglish ? fitLogoEn : fitLogoCs}
                            alt={t("Footer.fitLogoAlt")}
                        />
                    </a>
                    <p className="site-footer__text site-footer__academic-text">
                        <Trans
                            i18nKey="Footer.academicText"
                            components={{
                                person: <a href={t("Footer.personLink")} target="_blank" rel="noreferrer" />,
                                fit: <a href={t("Footer.fitLink")} target="_blank" rel="noreferrer" />
                            }}
                        />
                    </p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
